import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { BusinessEvent } from '@commons/models/domain/BusinessEvent';
import { NewDataStoreService } from '@shared/services/new-data-store.service';
import { Driver } from '@commons/models/domain/Driver';
import { Vehicle } from '@commons/models/domain/Vehicle';
import { Consts } from '@commons/consts/consts';

// enum ValueSign {
//   Plus = 1,
//   Minus = 2,
// }

@Component({
  selector: 'app-fuel-item',
  templateUrl: './fuel-item.component.html',
  styleUrls: ['./fuel-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FuelItemComponent implements OnInit {
  @Input() public eventData: BusinessEvent;

  public defaultVehicleName: string;
  public defaultDriverName: string;
  public driver?: Driver;
  public vehicle?: Vehicle;

  public valueLFuel?: number;
  public invoiceDiff?: number;
  public fuelEventActionTypeClass: Object;

  public readonly VALUE_SIGN = Consts;

  constructor(
    private translate: TranslateService,
    private newDataStoreService: NewDataStoreService,
  ) {
    this.defaultVehicleName = this.translate.instant('events-list.unknown-vehicle');
    this.defaultDriverName = this.translate.instant('events-list.unknown-driver');
  }

  public ngOnInit(): void {
    this.getVehicleData();
    this.getFuelData();
  }

  private getVehicleData(): void {
    if (this.eventData?.DI) {
      const driver = this.newDataStoreService.getDriverById(this.eventData?.DI);
      if (driver) {
        this.driver = driver;
      }
    }
    if (this.eventData?.VI) {
      const vehicle = this.newDataStoreService.getVehicleById(this.eventData?.VI);
      if (vehicle) {
        this.vehicle = vehicle;
      }
    }
  }

  private getFuelData(): void {
    if (this.eventData?.ED && this.eventData.ED.V) {
      this.valueLFuel = Math.abs(this.eventData.ED.V);
      if (this.eventData.ED.IV) {
          this.invoiceDiff = Math.abs(this.eventData.ED.V) - Math.abs(this.eventData.ED.IV);
      }
    }
  }

}
